import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MissingVariantsChecker from "./missingVariants";
import AdVariants from "./AdVariants";
import DeleteImagesVariants from "./deleteImages-variants";
import TriggerTranslation from "./translateText";
import LearnVideo from "./learnVideo";
import VideoManager from "./videoImagesUploads";
import "./Product.css";

function Product() {
  const navigate = useNavigate();

  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstall, setShowInstall] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstall(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    await deferredPrompt.userChoice;

    setDeferredPrompt(null);
    setShowInstall(false);
  };

  const actionItems = [
    { label: "Type Image", path: "/typeimage" },
    { label: "Theme and Info", path: "/themeandinfo" },
    { label: "Zoom / Category", path: "/zoomandcategory" },
    { label: "Upload Zone", path: "/uploadzone" },
    { label: "Users Order", path: "/userorder" },
    { label: "Get Item Information", path: "/getiteminformation" },
    { label: "Users Orders by Brand", path: "/userBrandPayment" },
    { label: "Add Theme in Brand", path: "/post-brand" },
    { label: "Modify Theme in Brand", path: "/modify-brand" },
    { label: "Fix Missing Dependency", path: "/missingDependencies" },
    { label: "Manage WhatsApp Data", path: "/whatsapp" },
    { label: "Continue Learning", path: "/continueLearn" },
     { label: "Add / Modify Brand Delivery", path: "/brand-delivery" },
  ];

  return (
    <div className="dashboard-page">
      <div className="dashboard-container">
        <header className="dashboard-header">
          <div>
            <h1>Workspace Dashboard</h1>
            <p>Manage products, brands, media, translations, and customer data.</p>
          </div>

          <div className="header-actions">
            <a
              href="https://user.malidag.com/downloads/malidag-setup.exe"
              className="secondary-btn"
            >
              Download Desktop App
            </a>

            {showInstall && (
              <button className="primary-btn" onClick={handleInstallClick}>
                Install App
              </button>
            )}
          </div>
        </header>

        <section className="dashboard-section">
          <div className="section-title">
            <h2>Learning</h2>
            <p>Start with training before managing products and brand content.</p>
          </div>

          <div className="card">
            <LearnVideo
              title="How to Add Products to Malidag"
              description="This video walks you through the process of uploading and managing products on the Malidag platform."
              videoUrl="https://www.youtube.com/embed/n0Emk8K94cc"
            />

            <div
              className="link-btnter"
              onClick={() => navigate("/continueLearn")}
            >
              Continue learning here
            </div>
          </div>
        </section>

        <section className="dashboard-section">
          <div className="section-title">
            <h2>Variant Tools</h2>
            <p>Review missing variants and manage variant-related media.</p>
          </div>

          <div className="tools-grid two-columns">
            <div className="card">
              <MissingVariantsChecker />
            </div>

            <div className="stack">
              <div className="card">
                <AdVariants />
              </div>
              <div className="card">
                <DeleteImagesVariants />
              </div>
            </div>
          </div>
        </section>

        <section className="dashboard-section">
          <div className="section-title">
            <h2>Main Actions</h2>
            <p>Quick access to the most important pages in the workspace.</p>
          </div>

          <div className="actions-grid">
            {actionItems.map((item) => (
              <button
                key={item.path}
                className="action-card"
                onClick={() => navigate(item.path)}
              >
                {item.label}
              </button>
            ))}
          </div>
        </section>

        <section className="dashboard-section">
          <div className="section-title">
            <h2>Media & Automation</h2>
            <p>Manage video uploads and translation workflows.</p>
          </div>

          <div className="tools-grid">
            <div className="card">
              <VideoManager />
            </div>

            <div className="card">
              <TriggerTranslation />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Product;